/**
 * @file role-access.ts
 * @module app/modules/service-request/utils/role-access
 * @description Matches the signed-in user's role against role IDs saved in a Settings multi-select.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.2
 * @version 2.1.2
 */

import { UserModel } from '../../auth/core/_models';

/** Splits a saved multi-select value ("id1,id2" or an array) into trimmed IDs. */
export const parseRoleIds = (value: unknown): string[] => {
  let parts: unknown[] = [];
  if (Array.isArray(value)) {
    parts = value;
  } else if (typeof value === 'string') {
    parts = value.split(',');
  }
  return parts
    .filter((id): id is string => typeof id === 'string')
    .map((id) => id.trim())
    .filter(Boolean);
};

/** Role ID the Settings role options use: the role reference, else the embedded role's _id. */
export const getCurrentUserRoleId = (currentUser?: UserModel): string =>
  String(
    currentUser?.roleAndPermission?.reference ||
      currentUser?.roleAndPermission?._id ||
      ''
  );
